export const LUNCH_MINUTES_PER_HOUR = 4;

export function isMngWorkShift(shift) {
  return Boolean(shift) && Number(shift.type_shift_id) === 1;
}

export function lunchHoursFromShiftHours(shiftHours) {
  const hours = Number(shiftHours) || 0;
  if (hours <= 0) return 0;
  return (hours * LUNCH_MINUTES_PER_HOUR) / 60;
}

export function shiftLunchHours(shift) {
  if (!isMngWorkShift(shift)) return 0;
  return lunchHoursFromShiftHours(shift.hours);
}

export function shiftWorkedHours(shift) {
  const hours = Number(shift?.hours) || 0;
  return Math.max(0, hours - shiftLunchHours(shift));
}

export function ceilToTenths(value) {
  if (!Number.isFinite(value) || value <= 0) return 0;
  const stabilized = Math.round(value * 1000) / 1000;
  return Math.ceil(stabilized * 10 - 1e-10) / 10;
}

export function formatMngHours(value, digits = 1) {
  return (Number(value) || 0).toLocaleString("ru-RU", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function employeeMonthHours(shifts) {
  let rawHours = 0;
  let lunch = 0;
  for (const shift of shifts || []) {
    if (!shift) continue;
    rawHours += Number(shift.hours) || 0;
    lunch += shiftLunchHours(shift);
  }
  const worked = Math.max(0, rawHours - lunch);
  return {
    rawHours,
    lunch,
    worked,
    hours: ceilToTenths(worked),
    fact: ceilToTenths(rawHours),
  };
}

function isWeekendDate(dateString) {
  const day = new Date(dateString).getDay();
  return day === 0 || day === 6;
}

export function adjustNormaForAbsences(shifts, normaHours) {
  let norma = Number(normaHours) || 0;
  for (const shift of shifts || []) {
    if (!shift) continue;
    const typeId = Number(shift.type_shift_id);
    if ((typeId === 5 || typeId === 6) && !isWeekendDate(shift.date)) {
      norma -= 8;
    }
  }
  return norma;
}

export function employeeMonthTotals(shifts, normaHours) {
  const month = employeeMonthHours(shifts);
  const norma = adjustNormaForAbsences(shifts, normaHours);
  const target = norma + month.lunch;
  return {
    ...month,
    norma,
    target,
    different: Math.round((norma - month.hours) * 10) / 10,
  };
}

export function dayFactHours(employee, dayIndex) {
  const value = Number(employee?.fact_hours?.[dayIndex]);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return value;
}

export function sumFactHours(factHours) {
  let total = 0;
  for (const value of factHours || []) {
    const hours = Number(value) || 0;
    if (hours > 0) total += hours;
  }
  return Math.round(total * 10) / 10;
}
